import React, {useMemo} from 'react';
import {Modal, Button, Typography, Checkbox} from 'antd';

import {useSettings} from '../../store/appData';

export type AgreementDialogProps = {
  title: string;
  open: boolean;
  handleCancel: () => void;
  LoginHomePage?: boolean;
  apiBaseURL: string;
};

const AgreementDialog: React.FC<AgreementDialogProps> = ({open, title, apiBaseURL, handleCancel, LoginHomePage}) => {
  const settings = useSettings();
  const canProceed = useMemo(() => {
    return !!(settings && settings.features);
  }, [settings]);

  const handleClick = () => {
    if (canProceed) {
      handleCancel();
      const authorizeURL = settings?.features?.accessAuthorizeEndPoint;
      const clientId = settings?.features?.clientId;
      // Preserve deep link for external users too
      const targetPath = localStorage.getItem('pendingDeepLink') || '';
      window.location.replace(
        authorizeURL +
          '?response_type=code&client_id=' +
          clientId +
          '&scope=openid%20MLMP&redirect_uri=' +
          apiBaseURL +
          '/api/v2/auth/login' +
          (targetPath ? '&state=' + encodeURIComponent(targetPath) : ''),
      );
    }
  };

  return (
    <Modal title={title} open={open} onOk={handleClick} onCancel={handleCancel} footer={null} closable={false}>
      <Typography.Paragraph>
        Model Repository is intended to help authorized parties external to Merck and MSD find, access, document, and
        analyze health economic models and their supporting files. This site is a scientific resource made available by
        the Biostatistical and Research Decision Sciences organization, a part of Merck and MSD&apos;s Research
        Laboratories.
        <br />
        Files contain certain proprietary or confidential methods, formulas, processes, techniques, and background
        technologies (collectively, “Material”) developed by Merck and MSD. Access, disclosure, download, use, and
        modifications of these materials must be in accordance with Merck and MSD&apos;s agreements with the external
        party.
      </Typography.Paragraph>
      <div style={{textAlign: 'center'}}>
        {LoginHomePage ? (
          <Button type="primary" onClick={handleClick}>
            I have read the agreement
          </Button>
        ) : (
          <div>
            <Checkbox onChange={handleCancel} />
            <span style={{color: 'blue', textDecoration: 'underline', marginLeft: '8px'}}>Read the agreement</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AgreementDialog;
